import { Component, ElementRef } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ToastController,
  AlertController,
  ViewController,
} from "ionic-angular";
import { AbstractPage } from '../../_com/abstract-page';
import { AuthStore } from '../../../stores/auth-store';
import { HttpFamilyProvider } from '../../../providers/http-family';
import { HttpStaffProvider } from '../../../providers/http-staff';
import Utils from '../../../_com/utils';
import { ModalController } from "ionic-angular";

/**
 * Generated class for the SignaturePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-signature-agreement",
  templateUrl: "signature-agreement.html",
})
export class SignatureAgreementPage extends AbstractPage {
  data = {
    id: "",
    family: {},
    agreement: false,
    agree_name: "",
    agree_date: "",
  };
  family = {};
  agreementId = "";
  text = "";
  get_date = new Date();
  signatureText: any;
  isSignatureTextExists: Boolean;

  _utils: Utils;

  // ご家族の入力が終われば、スタッフがパスワードを入力して元の画面に戻る
  isStaffConfirm: boolean = false;
  staffPassword: string = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    protected authStore: AuthStore,
    private httpFamilyProvider: HttpFamilyProvider,
    private toastController: ToastController,
    public alertController: AlertController,
    private el: ElementRef,
    private httpStaffProvider: HttpStaffProvider,
    private modalController: ModalController,
    public viewController: ViewController
  ) {
    super();

    if (!this.authStore.token) {
      return;
    }

    this.agreementId = this.navParams.data.agreementId;

    // ご家族情報は、前の画面からデータを貰うようにしておく
    // *** サンプルデータ ***
    // {
    //   "kana": "テストデータ", "tel": "0123456789", "modified_user": "5ad956f2a63367236c28f7b9",
    //   "modified": "2021-Sep-08 10:37:11", "created": "2019-Aug-26 12:27:57", "mail_address": "xxxxx@yahoo.co.jp",
    //   "name": "テストお名前", "tel2": "01012345678", "tel2_relation": "夫", "zip": 4520945, "address": "愛知県名古屋市",
    //   "sns_keisai_status": "true", "photo_uketori_status": "true", "children": ["5d635776a633672d6fbbc1dd"],
    //   "name2": "父", "id": "5d6351bda63367316fbbc1da"
    // }
    this.family = this.navParams.data.family || {};

    this.data.agree_date = this._Utils.date.format(
      this.get_date,
      "yyyy年MM月dd日(EEEE)"
    );

    this.refresh();
    //DOMアクセス準備
    super.readyDomAccess(this.el);
  }

  ionViewDidLoad() {
    if (!this.authStore.token) {
      return;
    }
    this.refresh();
  }

  refresh() {
    this.httpStaffProvider.getSignMessage().subscribe((res) => {
      if (res.data) {
        this.signatureText = res.data[0]["SignText"];
        this.text = res.data[0]["SignText"]["sign_text"];
        this.isSignatureTextExists = true;
      } else {
        this.signatureText = false;
        this.isSignatureTextExists = false;
      }
    });
  }

  /**
   * 入力した内容を保存する
   */
  save() {
    // 注意事項を理解したかどうかのチェック
    if (!this.data.agreement) {
      this.alert(
        this.alertController,
        "「注意事項を理解しました」にチェックを入れてください"
      );
      return;
    }

    this.data.id = this.agreementId; // idがない場合、更新
    this.data.family = this.family["id"]; // familyidのみデータとしてもつ
    this.data.agree_name = this.family["name"]; // 保護者名

    this.httpFamilyProvider.saveAgreement(this.data).subscribe((res) => {
      this.toast(this.toastController, "同意書に署名しました。");
      this.isStaffConfirm = true;
      // this.navCtrl.pop();
    });
  }

  close() {
    // TODO: ご家族に入力頂いた後の画面は、共通の画面となるのでコンポーネント化すべき
    // 端末をご家族の方にお渡ししているため、パスワード認証をかけておく
    if (this.staffPassword === "8710") {
      this.viewController.dismiss();
    } else {
      alert("パスワードが異なります");
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/signature/signature-agreement/signature-agreement.ts